import { render, staticRenderFns } from "./RegisterThankYou.vue?vue&type=template&id=52d2b439&"
import script from "./RegisterThankYou.vue?vue&type=script&lang=js&"
export * from "./RegisterThankYou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports